import { apiClient } from "lib/apiClient";
import { IDemographicsResponse } from "features/Demographics/types";

export const getAssetDashboardDemographics = async (
  propertyId: string
): Promise<IDemographicsResponse> => {
  const response = await apiClient.get(
    `/property/${propertyId}/asset-dashboard/demographics`
  );

  return response.data;
};
